// extracted by mini-css-extract-plugin
export default {"arcee":"resetcomp_arcee__wcGMp","arceeCont":"resetcomp_arceeCont__tzeUz"};